// extracted by mini-css-extract-plugin
module.exports = {"row":"styles_row__1zeyX","header":"styles_header__2sCw8","table":"styles_table__1SWhT"};